/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tired_Fancy_Moose_AdviseInputs */

const fr_tired_fancy_moose_advise = /** @type {(inputs: Tired_Fancy_Moose_AdviseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des contacts`)
};

/**

* @param {Tired_Fancy_Moose_AdviseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tired_fancy_moose_advise = /** @type {((inputs?: Tired_Fancy_Moose_AdviseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tired_Fancy_Moose_AdviseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tired_fancy_moose_advise(inputs)
});